import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/data/content";
import { Menu, X, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Logo";

const links = [
  { label: "Categories", href: "#categories" },
  { label: "Deliverables", href: "#deliverables" },
  { label: "Stay & Tour", href: "#stay-tour" },
  { label: "Packages", href: "#packages" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = ({ onRegister }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-nav py-3" : "py-5 bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="nav-logo">
          <Logo className="h-12 sm:h-14 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-zinc-300 hover:text-amber-300 transition-colors tracking-wide"
              data-testid={`nav-link-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/login"
            className="hidden sm:flex items-center gap-1.5 text-xs text-amber-200/80 hover:text-amber-300 transition-colors px-3 py-2"
            data-testid="nav-admin-login-button"
          >
            <ShieldCheck className="w-4 h-4" /> Team Login
          </Link>
          <button
            onClick={onRegister}
            className="gold-gradient-bg text-black font-600 text-sm px-5 py-2.5 rounded-full hover:brightness-110 transition-all"
            data-testid="nav-register-button"
          >
            Nominate Now
          </button>
          <button
            className="lg:hidden text-amber-200 p-1"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden glass-nav mt-3 mx-4 rounded-2xl p-5 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-zinc-200 hover:text-amber-300"
            >
              {l.label}
            </a>
          ))}
          <Link to="/login" className="text-amber-300 flex items-center gap-2">
            <ShieldCheck className="w-4 h-4" /> Team Login
          </Link>
        </div>
      )}
    </header>
  );
};
